import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/Auth'
import D0101Demo from '@/components/functions/D0101Demo/D0101DemoStore'
import M0001User from '@/components/functions/M0001User/M0001UserStore'
import M0004Purchase from '@/components/functions/M0004Purchase/M0004PurchaseStore'
import M0601Survey from '@/components/functions/M0601Survey/M0601SurveyStore'
import OnlineShop from '@/components/functions/M0006OnlineShop/M0006OnlineShopStore'
import Cart from '@/components/functions/M0008ShoppingCart/CartStore'
import CheckOut from '@/components/functions/M0009CheckOut/CheckOutStore'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import Contact from '@/components/functions/Contact/ContactStore'
import Client from '@/components/functions/Client/ClientStore'
import Gallery from '@/components/functions/Gallery/GalleryStore'

Vue.use(Vuex)
Vue.component('v-calendar', Calendar)
Vue.component('v-date-picker', DatePicker)

export default new Vuex.Store({
  modules: {
    Auth,
    D0101Demo,
    M0001User,
    M0004Purchase,
    M0601Survey,
    OnlineShop,
    Cart,
    CheckOut,
    Contact,
    Client,
    Gallery
  }
})
